/* global Conekta */
import validator from 'validator'
import moment from 'moment-timezone'

import { formatLongDate } from 'utils/dates'

const isEmpty = (value) => {
  try {
    return value === undefined || value === null || value.trim() === ''
  } catch (e) {
    return false
  }
}

export function required (value) {
  const invalid = isEmpty(value)
  if (invalid) {
    return 'Requisito'
  }
}

export function isLocation (value) {
  const hasLabel = value.label
  const hasCoordinates = value.location && value.location.lat && value.location.lat
  const invalid = !hasLabel || !hasCoordinates
  if (invalid) {
    return 'Debes elegir una dirección'
  }
}

export function isEmail (value) {
  const invalid = isEmpty(value) || !validator.isEmail(value)
  if (invalid) {
    return 'Debes proveer una dirección de correo electrónico válida'
  }
}

export function minLength (min) {
  return (value) => {
    const invalid = isEmpty(value) || value.length < min
    if (invalid) {
      return `Debe contener al menos ${min} caracteres`
    }
  }
}

export function sameAs (field, label = '') {
  return (value, values, props) => {
    const invalid = value !== values[field]
    if (invalid) {
      return `Debe ser igual a ${label}`
    }
  }
}

export function dateBetween (min, max) {
  const formattedMinDate = formatLongDate(min)
  const formattedMaxDate = formatLongDate(max)

  return (value) => {
    const invalid = !moment(value).isBetween(min, max, null, '[]')
    if (invalid) {
      return `Debes seleccionar un día entre el ${formattedMinDate} y ${formattedMaxDate}`
    }
  }
}

export function isCreditCardNumber (value = '') {
  const valid = Conekta.card.validateNumber(value)
  if (!valid) {
    return 'Debes escribir un número de tarjeta de credito valido'
  }
}

export function isCvcNumber (value = '') {
  const valid = Conekta.card.validateCVC(value)
  if (!valid) {
    return 'Debes escribir un código de seguridad valido'
  }
}

export function hasNotExpired (value, values) {
  const { exp_month: expMonth, exp_year: expYear } = values.creditCard || {}

  const isMissingDetails = expMonth === undefined || expYear === undefined
  if (isMissingDetails) {
    return
  }

  const valid = Conekta.card.validateExpirationDate(expMonth, expYear)
  if (!valid) {
    return 'La tarjeta de credito está expirada'
  }
}

export const createFieldValidator = (rules) => (value, values, props) => rules.map(rule => rule(value, values, props)).filter(error => !!error)[0]

/*
How to use createValidator:

createValidator needs a set of rules. rules is an object where the keys are the name
of the fields to validate, and the values is a validation function, or an array of validation functions.
*/
export function createValidator (rules = {}) {
  return (values = {}, props) => {
    const errors = {}

    Object.keys(rules).forEach(key => {
      const validate = createFieldValidator([].concat(rules[key]))
      const error = validate(values[key], values, props)

      if (error) {
        errors[key] = error
      }
    })

    return errors
  }
}



// WEBPACK FOOTER //
// ./src/screens/App/shared/utils/validations.js